import React, { useEffect, useState, forwardRef } from 'react';
import PropTypes from 'prop-types';
import {
  Slide,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
} from '@mui/material';
import { VIEW_COLUMNS } from '../../config/module-configs/app-sessions.config';
import Loading from '../table-elements/loading.component';
import ViewData from '../table-elements/view-data.component';
import { viewSessionById } from '../../services/reports.service';
import SnackbarInfo from '../common/snackbar-info.component';
import Iconify from '../common/iconify.component';

const Transition = forwardRef((props, ref) => (
  <Slide direction="up" ref={ref} {...props} />
));

const ViewSession = ({ title, dataId, onCancel, isLive = false }) => {
  const columns = VIEW_COLUMNS;
  const renderColumns = [];
  columns.forEach((item) => {
    if (!(isLive && item.id === 'sessionEndedAt')) {
      renderColumns.push(item);
    }
  });

  const [loading, setLoading] = useState(true);
  const [rowData, setRowData] = useState(null);
  const [snackbarInfo, setSnackbarInfo] = useState({
    show: false,
    type: '',
    message: '',
  });

  useEffect(() => {
    viewSessionById(dataId)
      .then((res) => {
        setRowData(res.data);
        setLoading(false);
      })
      .catch((err) => {
        const message =
          err.response?.data?.message ||
          'Something went wrong, please try again.';

        setSnackbarInfo({
          ...snackbarInfo,
          show: true,
          type: 'error',
          message,
        });
        setLoading(false);
      });
  }, [dataId]);

  return (
    <Dialog
      open
      onClose={() => onCancel()}
      aria-labelledby="view-dialog-title"
      aria-describedby="view-dialog-description"
      TransitionComponent={Transition}
      fullWidth
      maxWidth="lg"
    >
      <DialogTitle id="view-dialog-title">{title}</DialogTitle>
      <IconButton
        aria-label="close"
        onClick={onCancel}
        size="small"
        sx={{
          position: 'absolute',
          right: 10,
          top: 15,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <Iconify icon="ic:outline-close" />
      </IconButton>

      <DialogContent dividers id="view-dialog-description">
        {loading && <Loading />}

        {!loading && <ViewData columns={renderColumns} row={rowData} />}
      </DialogContent>

      {snackbarInfo.show && (
        <SnackbarInfo type={snackbarInfo.type} message={snackbarInfo.message} />
      )}
    </Dialog>
  );
};

ViewSession.propTypes = {
  title: PropTypes.string.isRequired,
  dataId: PropTypes.number.isRequired,
  onCancel: PropTypes.func.isRequired,
  isLive: PropTypes.any.isRequired,
};

export default ViewSession;
